import TournamentRegisteredUsers from '@features/tournament-details/tournament-registered/tournament-registered';
export default TournamentRegisteredUsers;
